<script>
import apiServices from '@/services/yungol-services'

export default {
  template: `<div class="buttons is-justify-end" style='width: 100%; height: 100%; margin: auto; margin-top: 2px'>
    <button class="button is-danger" v-on:click="deleteDependence()">
        <span v-tooltip="'Eliminar'" class="icon">
          <i class="material-icons">delete_forever</i>
        </span>
    </button>
  </div>`,
  data(){
    return {
      params: this.$parent.params
    }
  },
  props:{},
  methods:{
    async deleteDependence() {
      const config = {
        title: '¿Estás seguro?',
        text: "Al eliminar no se podrá recuperar la dependencia después.",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, eliminar'
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const result = await apiServices.delete(`/deletedependenciaclima/${this.params.value}`);
            if (result.data) {
              await this.$swal({
                text: 'Dependecia eliminada correctamente.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
              await this.getEmployees()
              this.params.api.applyTransaction({
                remove: [this.params.node.data],
              });
            }
          } catch (err) {
            await this.$swal({
              text: 'Error al eliminar la dependencia.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
            console.log(err)
          }
        }
      });
    },
    async getEmployees (){
      await this.$emit('getEmployees')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/climan/components/buttonsActionDependence.vue